import React from 'react'

export const TailwindContext = React.createContext({
  theme: null,
  getBreakpointInPixels: () => {}
})
